<div class="container px-3 py-4">
  <div class="grid-container">
    <button matButton="outlined" (click)="startAdd()">Add Mapping</button>
    <button matButton="outlined" (click)="startDeleteAll()">Delete All Mapping and Token</button>
    @if(settingsReady)
    {
      <app-lt-png-table [gridSettingsInput]="gridSettings()" (deleteClicked)="confirmDelete($event)">
        <ng-template appGridTemplate="expandedrow" let-data let-rowIndex="rowIndex ">
          <section>
            <app-los-token-mapping-view [data]="data" (mappingDataChanged)="reloadActiveToken()" />
          </section>
        </ng-template>
      </app-lt-png-table>
    }
  </div>

  <ng-template #confirmDeleteDialog>
    <h3 mat-dialog-title>Do you wish to delete LOS Token Mapping?</h3>
    <div mat-dialog-actions>
      <button matButton="outlined" (click)="closeDialog()">No</button>
      <button matButton="outlined" (click)="checkDeleteMapping()" cdkFocusInitial>Yes</button>
    </div>
  </ng-template>

  <ng-template #confirmDeleteTokenDialog>
    <h3 mat-dialog-title>Are you sure wish to delete the LOS Token?</h3>
    <div mat-dialog-content>
      LOS Token Mapping being deleted is the only LOS Token Mapping for LOS Token.<br />
      If you delete the LOS Token Mapping, the LOS Token will be deleted too.<br />
      Do you wish to delete the LOS Token Mapping and LOS Token?
    </div>
    <div mat-dialog-actions>
      <button matButton="outlined" (click)="closeDialog()">No</button>
      <button matButton="outlined" (click)="deleteToken()" cdkFocusInitial>Yes</button>
    </div>
  </ng-template>

  <ng-template #confirmDeleteAllDialog>
    <h3 mat-dialog-title>Are you sure wish to delete all the LOS Token Mappings and LOS Token?</h3>
    <div mat-dialog-actions>
      <button matButton="outlined" (click)="closeDialog()">No</button>
      <button matButton="outlined" (click)="deleteToken()" cdkFocusInitial>Yes</button>
    </div>
  </ng-template>

  <ng-template #addMappingDialog>
    <h3 mat-dialog-title>Add Mapping for LOS Token</h3>
    <div mat-dialog-content>
      @if(availableIntegrations.length > 0)
      {
        <ng-container>
          <app-lt-dropdown
            [label]="'Select Integration'"
            [data]="availableIntegrations"
            [textField]="name"
            [valueField]="integrationId"
            [displayWithFn]="displayIntegration"
            (selectionChange)="selectIntegration($event)">
          </app-lt-dropdown>
        </ng-container>
      }
      @if(availableIntegrations.length === 0)
      {
        <ng-container>
          There are no available integrations to add a token to
        </ng-container>
      }
    </div>
    <div mat-dialog-actions>
      <button matButton="outlined" (click)="closeDialog()">Cancel</button>
      <button matButton="outlined" (click)="addNewMapping()" cdkFocusInitial [disabled]="!selectedIntegration">Submit</button>
    </div>
  </ng-template>
</div>
